import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrdersResByIDSet(order_ids){
    var payload = await GetSeferData("rf4", {'ORDER_ID': order_ids});
    return (payload);
}